import React from 'react';
import { useTranslation } from 'next-i18next';
import { Order } from '@interfaces/models/order';
import styles from './floating-cart-price.module.scss';

// TODO: Just use RQ instead of props
type FloatingCartPriceProps = {
  currentCart?: Order;
};

export const FloatingCartPrice: React.FC<FloatingCartPriceProps> = ({ currentCart }) => {
  const { t } = useTranslation('default-layout');
  return (
    <div className={styles.cartPreview__total}>
      <span className={styles.cartPreview__total__label}>{t('HEADER.FLOATING_CART.SUBTOTAL')}</span>
      <span
        className={styles.cartPreview__total__amount}
        data-cy="cartpreview_total_amount"
        role="status"
        aria-atomic="true"
        aria-live="polite"
      >
        {currentCart?.itemsAmount?.formatted}
      </span>
    </div>
  );
};
